export default function reverseStringChars(string) {
  return string.replace(/./g, c => c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase());
}